import { render, staticRenderFns } from "./CardSummary.vue?vue&type=template&id=296aa29c&scoped=true&"
import script from "./CardSummary.vue?vue&type=script&lang=js&"
export * from "./CardSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296aa29c",
  null
  
)

export default component.exports